import type { FC, ReactNode } from 'react'
import type { BlogPostSummary } from '@/types'

import { cn } from '@/lib/utils'
import { formatDate } from '@/lib/format'

interface PostMetaProps {
    post: BlogPostSummary
    className?: string
    showDate?: boolean
}

/** Category, reading time and date for a blog post, each value editable in place. */
export const PostMeta: FC<PostMetaProps> = ({ post, className, showDate = true }): ReactNode => (
    <p className={cn('t-label flex flex-wrap items-center gap-x-3 gap-y-1 text-tone-muted', className)}>
        {post.category && (
            <span className='text-tone-ink' data-mdlfy-cms={`blog_categories:${post.category.id}:name`}>
                {post.category.name}
            </span>
        )}

        {post.readTime && (
            <span>
                <span data-mdlfy-cms={`blog_posts:${post.id}:read_time`}>{post.readTime}</span> min lesetid
            </span>
        )}

        {showDate && <span>{formatDate(post.publishedAt)}</span>}
    </p>
)
